var _defs, _rect, _rect2, _rect3, _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _circle9, _circle0, _circle1, _circle10, _circle11, _circle12, _circle13, _circle14;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgServiceCloudSolutions(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1200 800",
    width: 1200,
    height: 800,
    role: "img",
    "aria-label": "Abstract illustration",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "gcloudsolutio",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#2F6560"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#163936"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "wcloudsolutio",
    cx: 0.2,
    cy: 0.1,
    r: 0.9
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#83ADA9",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#83ADA9",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "ocloudsolutio",
    cx: 0.85,
    cy: 0.85,
    r: 0.6
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#FF4804",
    stopOpacity: 0.22
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF4804",
    stopOpacity: 0
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 1200,
    height: 800,
    fill: "#F5F8F7"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 1200,
    height: 800,
    fill: "url(#wcloudsolutio)"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 1200,
    height: 800,
    fill: "url(#ocloudsolutio)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 382.5576648581773,
    cy: 400,
    r: 120,
    fill: "none",
    stroke: "#548A85",
    strokeOpacity: 0.42,
    strokeWidth: 1.4
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 382.5576648581773,
    cy: 400,
    r: 225,
    fill: "none",
    stroke: "#548A85",
    strokeOpacity: 0.36,
    strokeWidth: 1.4,
    strokeDasharray: "2 14",
    strokeLinecap: "round"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 382.5576648581773,
    cy: 400,
    r: 330,
    fill: "none",
    stroke: "#548A85",
    strokeOpacity: 0.31,
    strokeWidth: 2.5
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 382.5576648581773,
    cy: 400,
    r: 435,
    fill: "none",
    stroke: "#548A85",
    strokeOpacity: 0.26,
    strokeWidth: 1.4,
    strokeDasharray: "2 14",
    strokeLinecap: "round"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 382.5576648581773,
    cy: 400,
    r: 540,
    fill: "none",
    stroke: "#548A85",
    strokeOpacity: 0.2,
    strokeWidth: 1.4
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 382.5576648581773,
    cy: 400,
    r: 645,
    fill: "none",
    stroke: "#548A85",
    strokeOpacity: 0.14,
    strokeWidth: 1.4,
    strokeDasharray: "2 14",
    strokeLinecap: "round"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 382.5576648581773,
    cy: 400,
    r: 58,
    fill: "url(#gcloudsolutio)"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 382.5576648581773,
    cy: 400,
    r: 92,
    fill: "none",
    stroke: "#FF4804",
    strokeOpacity: 0.5,
    strokeWidth: 2
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 880,
    cy: 308.2905082218349,
    r: 46,
    fill: "none",
    stroke: "#548A85",
    strokeOpacity: 0.3,
    strokeWidth: 1.4
  })), _circle0 || (_circle0 = /*#__PURE__*/React.createElement("circle", {
    cx: 880,
    cy: 308.2905082218349,
    r: 86,
    fill: "none",
    stroke: "#548A85",
    strokeOpacity: 0.22,
    strokeWidth: 1.4
  })), _circle1 || (_circle1 = /*#__PURE__*/React.createElement("circle", {
    cx: 880,
    cy: 308.2905082218349,
    r: 126,
    fill: "none",
    stroke: "#548A85",
    strokeOpacity: 0.14,
    strokeWidth: 1.4
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 880,
    cy: 308.2905082218349,
    r: 22,
    fill: "#2F6560",
    fillOpacity: 0.75
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    cx: 493,
    cy: 820.7,
    r: 8,
    fill: "#83ADA9",
    fillOpacity: 0.85
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    cx: 318.6,
    cy: 76.3,
    r: 13,
    fill: "#FF4804",
    fillOpacity: 1
  })), _circle13 || (_circle13 = /*#__PURE__*/React.createElement("circle", {
    cx: 25.6,
    cy: 151.5,
    r: 8,
    fill: "#83ADA9",
    fillOpacity: 0.85
  })), _circle14 || (_circle14 = /*#__PURE__*/React.createElement("circle", {
    cx: -51.2,
    cy: 432.8,
    r: 8,
    fill: "#83ADA9",
    fillOpacity: 0.85
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgServiceCloudSolutions);
export default __webpack_public_path__ + "static/media/service-cloud-solutions.2146c699b954aafb84a3b39450a1f038.svg";
export { ForwardRef as ReactComponent };